(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-brand-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const closeMenus = (except) => document.querySelectorAll('.ms-catalog-navigation details[open]').forEach((item) => {
    if (item !== except) item.open = false;
  });
  document.addEventListener('toggle', (event) => {
    if (event.target.matches('.ms-catalog-navigation details') && event.target.open) closeMenus(event.target);
  }, true);
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.ms-catalog-navigation')) closeMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('.ms-catalog-navigation details[open]');
    if (menu) {
      event.stopPropagation();
      menu.open = false;
      menu.querySelector('summary').focus();
    } else closeMenus();
  });
  document.addEventListener('focusin', (event) => {
    if (event.target.closest('.ms-catalog-navigation')) return;
    // Safari focust bij een tik op een link niet de link maar de lade eromheen.
    // Dat is geen verlaten van het menu; sloot het submenu hier, dan verdween
    // de link voordat de klik aankwam (MAT-800).
    if (event.target.querySelector('.ms-catalog-navigation')) return;
    closeMenus();
  });
  window.addEventListener('resize', () => closeMenus());
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-lookbook-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-lookbook')) {
  customElements.define('ms-lookbook', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.editor === 'true') {
        this.startFrame = requestAnimationFrame(() => this.mount());
        return;
      }
      // Meet en activeer alleen secties die bijna in beeld komen.
      this.entryObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.entryObserver.disconnect();
        this.startFrame = requestAnimationFrame(() => this.mount());
      }, {rootMargin: '500px 0px'});
      this.entryObserver.observe(this);
    }
    disconnectedCallback() {
      this.entryObserver?.disconnect();
      cancelAnimationFrame(this.startFrame);
      this.controller?.abort();
      this.observers?.forEach(observer => observer.disconnect());
      this.frames?.forEach(frame => cancelAnimationFrame(frame));
      this.animations?.forEach(animation => animation.cancel());
      this.querySelector('video')?.pause();
      this.removeAttribute('data-ready');
    }
    mount() {
      if (!this.isConnected || this.hasAttribute('data-ready')) return;
      this.controller = new AbortController();
      this.observers = []; this.frames = new Set(); this.animations = new Set();
      const signal = this.controller.signal;
      const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, {...options, signal});
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const viewport = matchMedia('(min-width: 990px) and (min-height: 700px) and (pointer: fine)');
      const clamp = (n, max) => Math.min(max, Math.max(0, n));
      const motions = new Map();
      const story = this.querySelector('.scroll-story');
      const editor = this.dataset.editor === 'true';
      if (story) {
        const stage = story.querySelector('.scroll-stage'), rail = story.querySelector('.rail'), hint = story.querySelector('.rail-hint');
        let active = false, distance = 0, top = 0, expected = rail.scrollLeft, frame = 0;
        const start = () => window.scrollY + story.getBoundingClientRect().top - top;
        const render = () => { this.frames.delete(frame); frame = 0; if (!active) return; rail.scrollLeft = clamp(window.scrollY - start(), distance); expected = rail.scrollLeft; };
        const schedule = () => { if (active && !frame) { frame = requestAnimationFrame(render); this.frames.add(frame); } };
        const go = (left, behavior = 'smooth') => window.scrollTo({top:start() + clamp(left, distance), behavior});
        const measure = () => {
          if (signal.aborted) return;
          active = viewport.matches && !reduced.matches && !editor;
          story.classList.toggle('is-scroll-story', active);
          let height = stage.getBoundingClientRect().height;
          if (height > innerHeight - 16) { active = false; story.classList.remove('is-scroll-story'); }
          if (active) {
            distance = Math.max(0, rail.scrollWidth - rail.clientWidth); top = Math.max(0, (innerHeight - height)/2);
            story.style.setProperty('--story-height', `${height + distance}px`); story.style.setProperty('--story-top', `${top}px`);
            motions.set(rail, go); hint.textContent = hint.dataset.motion; render();
          } else {
            motions.delete(rail); story.style.removeProperty('--story-height'); story.style.removeProperty('--story-top'); hint.textContent = hint.dataset.static;
          }
        };
        on(window, 'scroll', schedule, {passive:true}); on(window, 'resize', measure); on(reduced, 'change', measure); on(viewport, 'change', measure);
        on(rail, 'scroll', () => { if (active && Math.abs(rail.scrollLeft - expected)>2) { expected = rail.scrollLeft; go(expected, 'instant'); } }, {passive:true});
        document.fonts.ready.then(measure); measure();
      }
      const move = (rail,left) => motions.has(rail) ? motions.get(rail)(left) : rail.scrollTo({left,behavior:reduced.matches?'instant':'smooth'});
      this.querySelectorAll('.rail-controls').forEach(controls => {
        const rail = this.querySelector(`[id="${controls.dataset.for}"]`);
        if (!rail) return;
        const previous = controls.querySelector('[data-dir="-1"]'), next = controls.querySelector('[data-dir="1"]');
        let progress = rail.nextElementSibling;
        if (!progress?.classList.contains('rail-progress')) {
          progress = document.createElement('div'); progress.className = 'rail-progress wrap'; progress.setAttribute('aria-hidden','true'); progress.append(document.createElement('span')); rail.after(progress);
        }
        const update = () => {
          const max = rail.scrollWidth - rail.clientWidth; previous.disabled = rail.scrollLeft < 2; next.disabled = rail.scrollLeft >= max-2;
          progress.style.setProperty('--rail-progress',max>0?(rail.scrollLeft+rail.clientWidth)/rail.scrollWidth:1);
        };
        controls.querySelectorAll('button').forEach(button => on(button,'click',() => {
          const card = [...rail.children].find(item=>!item.hidden), gap = parseFloat(getComputedStyle(rail).gap)||0;
          move(rail,rail.scrollLeft + Number(button.dataset.dir)*((card?.getBoundingClientRect().width||rail.clientWidth)+gap));
        }));
        on(rail,'scroll',update,{passive:true});
        on(rail,'keydown',event=>{
          if(event.target!==rail || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          event.preventDefault();
          if(['Home','End'].includes(event.key))move(rail,event.key==='Home'?0:rail.scrollWidth);
          else (event.key==='ArrowLeft'?previous:next).click();
        });
        const resize = new ResizeObserver(update); resize.observe(rail); this.observers.push(resize);
        on(rail,'collection-filter',update); update();
      });
      const products = this.querySelector('.product-rail,.project-rail');
      if(products) this.querySelectorAll('[data-filter]').forEach(button=>on(button,'click',()=>{
        this.querySelectorAll('[data-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        let count=0;
        products.querySelectorAll('[data-group]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.group!==button.dataset.filter;if(!card.hidden)count++;});
        products.scrollTo({left:0,behavior:'instant'});
        const total=this.querySelector('.product-count'); total.textContent=`${count} ${count===1?total.dataset.singular:total.dataset.plural}`;
        products.dispatchEvent(new Event('collection-filter'));
      }));
      // MAT-797: wissel de standen van de maatwerkkast zolang hij in beeld is; bij reduced motion alleen op verzoek.
      const maatwerk=this.querySelector('[data-maatwerk]');
      if(maatwerk){
        const states=[...maatwerk.querySelectorAll('.maatwerk-state')],link=maatwerk.querySelector('.maatwerk-link'),toggle=maatwerk.querySelector('.maatwerk-toggle');
        let index=0,timer=0,inView=false,paused=false;
        const show=next=>{if(!states.length)return;index=(next+states.length)%states.length;
          states.forEach((state,i)=>{state.classList.toggle('is-active',i===index);state.setAttribute('aria-hidden',String(i!==index));});
          const state=states[index];maatwerk.style.setProperty('--tint',state.dataset.tint);if(link)link.href=link.href.replace(/#.*$/,'')+'#kast='+state.dataset.code;};
        // Bij reduced motion is de knop "volgende"; anders pauzeert of hervat hij het wisselen.
        const label=()=>{if(reduced.matches){toggle.textContent=toggle.dataset.next;toggle.removeAttribute('aria-pressed');}
          else{toggle.textContent=paused?toggle.dataset.play:toggle.dataset.pause;toggle.setAttribute('aria-pressed',String(paused));}};
        const sync=()=>{clearInterval(timer);if(!paused&&!reduced.matches&&inView&&!document.hidden&&states.length>1)timer=setInterval(()=>show(index+1),3500);};
        toggle.hidden=states.length<2;
        on(toggle,'click',()=>{if(reduced.matches)show(index+1);else paused=!paused;label();sync();});
        on(document,'visibilitychange',sync);on(reduced,'change',()=>{label();sync();});
        const seen=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;sync();},{threshold:.3});seen.observe(maatwerk);this.observers.push(seen);
        show(0);label();
        signal.addEventListener('abort',()=>clearInterval(timer));
      }
      // MAT-794: de Google-reviewwidget (Elfsight) laadt pas als de showroomsectie in beeld komt.
      const reviews=this.querySelector('.showroom-reviews [class^="elfsight-app-"]');
      if(reviews){
        const near=new IntersectionObserver(entries=>{
          if(!entries[0].isIntersecting)return;near.disconnect();
          if(!document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')){const script=document.createElement('script');script.src='https://static.elfsight.com/platform/platform.js';script.async=true;document.head.append(script);}
        },{rootMargin:'300px 0px'});near.observe(reviews);this.observers.push(near);
      }
      // MAT-787: bannervideo na het laden van de pagina; het beeld eronder blijft tot hij echt speelt.
      // MAT-836: vanaf 990 px de desktopvideo, tot 749 px de staande mobiele video, daartussen alleen het beeld.
      const hero=this.querySelector('.hero-video');
      if(hero){
        const desktop=matchMedia('(min-width: 990px)'),mobile=matchMedia('(max-width: 749px)');let heroInView=true;
        const syncHero=()=>{
          const source=desktop.matches?hero.dataset.src:mobile.matches?hero.dataset.mobileSrc:undefined;
          if(!source||reduced.matches||document.hidden||!heroInView){hero.pause();if(!source||reduced.matches)hero.classList.remove('is-playing');return;}
          const swap=hero.getAttribute('src')!==source;
          if(swap){hero.classList.remove('is-playing');hero.src=source;}
          if(swap||hero.paused)hero.play().then(()=>hero.classList.add('is-playing')).catch(()=>{});
        };
        const start=()=>{on(desktop,'change',syncHero);on(mobile,'change',syncHero);on(reduced,'change',syncHero);on(document,'visibilitychange',syncHero);
          const seen=new IntersectionObserver(entries=>{heroInView=entries[0].isIntersecting;syncHero();});seen.observe(hero);this.observers.push(seen);};
        if(document.readyState==='complete')start();else on(window,'load',start,{once:true});
      }
      const film=this.querySelector('video.morning-film'),play=this.querySelector('.play-film'),status=this.querySelector('.film-status');
      // MAT-873: de poster laadt pas als de film in de buurt komt. Een poster laadt ook bij preload="none", en deelde bij het openen de lijn met het bannerbeeld.
      if(film?.dataset.poster){const near=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)return;near.disconnect();film.poster=film.dataset.poster;},{rootMargin:'600px 0px'});near.observe(film);this.observers.push(near);}
      if(film&&play){
        const load=()=>{if(!film.querySelector('source[src]')){film.querySelectorAll('source[data-src]').forEach(source=>source.src=source.dataset.src);film.load();}};
        on(play,'click',async()=>{
          status.textContent='';
          load();
          film.controls=true;
          try{await film.play();if(!signal.aborted)play.hidden=true;}catch{if(!signal.aborted){status.textContent=status.dataset.error;play.hidden=false;}}
        });
        on(film,'play',()=>play.hidden=true);
        on(film,'error',()=>{status.textContent=status.dataset.error;play.hidden=false;});
        // Gedempt automatisch afspelen zodra de film in beeld is en de tab zichtbaar (MAT-790); de bron laadt pas dan.
        // Met reduced motion of in de editor blijft de startknop. Na een klik op de knop (controls) beslist de bezoeker.
        let inView=false;
        const sync=()=>{
          if(!inView||document.hidden){film.pause();return;}
          if(film.controls||editor)return;
          if(reduced.matches){film.pause();play.hidden=false;return;}
          if(film.paused){load();film.play().catch(()=>{play.hidden=false;});}
        };
        on(document,'visibilitychange',sync);on(reduced,'change',sync);
        const visible=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;sync();},{threshold:.35});visible.observe(film);this.observers.push(visible);
      }
      if(!editor){
        const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{
          if(!entry.isIntersecting)return;reveal.unobserve(entry.target);if(reduced.matches)return;
          const animation=entry.target.animate([{opacity:.25,transform:'translateY(20px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.2,.65,.3,1)'});
          this.animations.add(animation);animation.onfinish=()=>this.animations.delete(animation);
        }),{threshold:.12});
        this.querySelectorAll('.film-heading,.island-copy,.details-section figure,.showroom').forEach(element=>reveal.observe(element));this.observers.push(reveal);
      }
      on(reduced,'change',()=>{if(reduced.matches){this.animations.forEach(animation=>animation.cancel());this.animations.clear();}});
      if (editor) on(this, 'shopify:block:select', event => {
        const card = event.target.closest('[data-shopify-editor-block]');
        if (card && this.contains(card)) card.scrollIntoView({block:'nearest',inline:'center',behavior:'instant'});
      });
      this.setAttribute('data-ready','');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
